// Wraps button label text into a two-copy "roll" structure so the text can
// flip upward on hover (the bottom copy slides in). Icons and other element
// children are left untouched — only direct text nodes are wrapped.
export function buttonRoll() {
  const buttons = document.querySelectorAll(".button");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    if (button.dataset.roll !== undefined) return;
    button.dataset.roll = "";

    // Only direct, non-empty text nodes — keeps icons/pseudo content in place.
    const textNodes = [...button.childNodes].filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());

    textNodes.forEach((textNode) => wrapTextNode(textNode));
  });
}

function wrapTextNode(textNode) {
  const value = textNode.textContent.trim();

  const roll = document.createElement("span");
  roll.className = "button__roll";

  const track = document.createElement("span");
  track.className = "button__roll-track";

  const first = document.createElement("span");
  first.className = "button__roll-item";
  first.textContent = value;

  // Duplicate copy that slides in from below — hidden from assistive tech.
  const second = first.cloneNode(true);
  second.setAttribute("aria-hidden", "true");

  track.append(first, second);
  roll.append(track);
  textNode.replaceWith(roll);
}
